import React, { useEffect } from 'react';
import { AccordionContent } from './AccordionContent.js';
import { AccordionItem } from './AccordionItem.js';
import { AccordionItemContent } from './AccordionItemContent.js';
import { useAccordionRoot } from './AccordionRootProvider.js';
import { StyledAccordionTrigger, StyledAccordionItemGroup, AccordionItemText, AccordionChevronIcon, AccordionList } from './styles.js';
import { removeTrailingSlash } from './utils.js';
import '../../Text/Caption/Caption.js';
import '../../Text/DetailedSubheading/DetailedSubheading.js';
import '../../Text/OverlineLg/OverlineLg.js';
import '../../Text/OverlineMd/OverlineMd.js';
import ParagraphLg from '../../Text/ParagraphLg/ParagraphLg.js';
import '../../Text/ParagraphMd/ParagraphMd.js';
import '../../Text/SectionHeading/SectionHeading.js';
import '../../Text/SectionSubheading/SectionSubheading.js';
import '../../Text/Title/Title.js';
import { StyledTooltip } from '../styles.js';

function CollapsibleItem({ name, Icon, items, onChange, isSideNavExpanded, startAnimations, isSideNavVisible, }) {
    const { openedAccordion, setOpenedAccordion } = useAccordionRoot();
    const isActive = items.some((item) => removeTrailingSlash(window.location.pathname).includes(removeTrailingSlash(item.url)));
    const isOpened = openedAccordion === name;
    function handleExpanded() {
        if (!isSideNavExpanded) {
            onChange();
        }
    }
    useEffect(() => {
        if (!isSideNavExpanded) {
            setOpenedAccordion('');
        }
    }, [isSideNavExpanded]);
    return (React.createElement(AccordionItem, { value: name },
        React.createElement(StyledTooltip, Object.assign({ content: name, side: "right" }, (isSideNavExpanded ? { forceOpen: false } : undefined)),
            React.createElement("li", null,
                React.createElement(StyledAccordionTrigger, { onClick: handleExpanded, "data-tracking-name": name, "data-tracking-props": { isSideNavigation: true } },
                    React.createElement(StyledAccordionItemGroup, { isActive: isActive, isSideNavVisible: isSideNavVisible, isSideNavExpanded: isSideNavExpanded, as: "div" }, Icon !== null && Icon !== void 0 ? Icon : null,
                        React.createElement(AccordionItemText, { isSideNavExpanded: isSideNavExpanded, startAnimations: startAnimations, isSideNavVisible: isSideNavVisible },
                            React.createElement(ParagraphLg, { as: "span" }, name),
                            React.createElement(AccordionChevronIcon, { "$isOpened": isOpened })))),
                React.createElement(AccordionContent, null,
                    React.createElement(AccordionList, null, items.map((item) => {
                        return (React.createElement(AccordionItemContent, { key: item.name, Icon: item.Icon, name: item.name, href: item.url, badge: item.label, startAnimations: startAnimations, isSideNavExpanded: isSideNavExpanded, isSideNavVisible: isSideNavVisible, onClick: item === null || item === void 0 ? void 0 : item.onClick }));
                    })))))));
}

export { CollapsibleItem };
